// import {CakeReducer} from './Cakes/CakeReducer';
import { RootReducer } from './RootReducer';
import {applyMiddleware, legacy_createStore as createStore} from 'redux';
import thunk from 'redux-thunk';

export const store = createStore(RootReducer, applyMiddleware(thunk));

// export default store;